const e = "CookieConsentsService";
export {
  e as COOKIE_CONSENTS_SERVICE
};
